import { render, staticRenderFns } from "./signUser.vue?vue&type=template&id=58944a6f&scoped=true&"
import script from "./signUser.vue?vue&type=script&lang=js&"
export * from "./signUser.vue?vue&type=script&lang=js&"
import style0 from "./signUser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./signUser.vue?vue&type=style&index=1&id=58944a6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58944a6f",
  null
  
)

export default component.exports